// extracted by mini-css-extract-plugin
export default {"main":"main_main__RgFTW","container":"main_container__TDEWf"};